export default __webpack_public_path__ + "static/media/sm.0aa4465c.jpg";